import { render, staticRenderFns } from "./members_help.vue?vue&type=template&id=27c97296&scoped=true&"
import script from "./members_help.vue?vue&type=script&lang=js&"
export * from "./members_help.vue?vue&type=script&lang=js&"
import style0 from "./members_help.vue?vue&type=style&index=0&id=27c97296&prod&lang=scss&"
import style1 from "./members_help.vue?vue&type=style&index=1&id=27c97296&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c97296",
  null
  
)

export default component.exports